import
  {
    JiraImportIssueOverviewResponse,
    JiraImportVersionOverviewResponse,
    Product,
    Subscription,
    Version,
  } from "../../../services/api";

export interface IProductState
{
  deletedProducts: Product[];
  deletedVersions: Version[];
  filterProductText: string;
  filterProductType: string[];
  filterProductFavorites: number[];
  products: Product[] | null;
  selectedProduct: Product;
  selectedVersionId: number | null;
  jiraVersions: JiraImportVersionOverviewResponse[];
  jiraVersion: JiraImportVersionOverviewResponse;
  jiraNote: JiraImportIssueOverviewResponse;
  emailSubscriptions: Subscription[];
}

export const defaultProductState: IProductState = {
  deletedProducts: [],
  deletedVersions: [],
  filterProductText: "",
  filterProductType: [],
  filterProductFavorites: [],
  products: null,
  selectedVersionId: null,
  selectedProduct: {
    versions: undefined,
  },
  jiraVersions: [],
  jiraVersion: {},
  jiraNote: {},
  emailSubscriptions: [],
};
